import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./Profile.css";
import { useAuth } from "../../../firebase/AuthProvider";
import { getAvatarsFromStorage, uploadAvatar } from "../../../services/fileServices/FileService";
import Avatar from "../../../interfaces/avatar/Avatar";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Profileinformationtab from "../profileInformationtab/Profileinformationtab";
import Notificationtab from "../notificationtab/Notificationtab";
import Reviewtab from "../../reviewtab/Reviewtab";
import Securitytab from "../securitytab/Securitytab";
import FrameProfile from "../../../assets/images/FrameProfile.png";
import AvatarImage from "../../ui/Avatar/AvatarImage";
import editicon from "../../../assets/images/EDIT.png";
import EDITICON from "../../../assets/images/EDITICON-Pro.svg";
import { toast } from "react-toastify";
import { GetEmployeeFileAsync, GetEmployeeProfileDetailsAsync, getUpcomingTimeOffs, UpdateContactAndTimezoneAsync, UpdateUserAddressAsync } from "../../../services/EmployeeService/EmployeeService";
import { EmployeeTimeOffResponseDto, GetEmployeeFilesRequest, GetEmployeeProfileDto, GetEmployeFilesResponse, UpdateContactAndTimezoneRequest, UpdateAddressRequest } from "../../../interfaces/Employee/Employee";
import { useAvatarCache } from "../../../contexts/AvatarContext";
import { positionRanks } from "../../../utilities/PostitionRanks";
import { MdOutlineEdit } from "react-icons/md";
import { AxiosError } from "axios";
import { IoCloseOutline } from "react-icons/io5";





const Profile: React.FC = () => {
  const { currentUser, currentUserInfo } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [currentAvatar, setCurrentAvatar] = useState<Avatar | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<GetEmployeeProfileDto>();
  const [filesData, setFilesData] = useState<GetEmployeFilesResponse[]>([]);
  const [authToken, setAuthToken] = useState<string>("");
  const { refreshAvatar } = useAvatarCache(); // Get the refreshAvatar function
  const [timeZoneUpdating, setTimezoneUpdating] = useState<boolean>(false);
  const [isEditingAddress, setIsEditingAddress] = useState<boolean>(false);
  const [editedAddress, setEditedAddress] = useState<string>("");
  const [addressUpdating, setAddressUpdating] = useState<boolean>(false);
  const [isEditingPhone, setIsEditingPhone] = useState<boolean>(false);
  const [editedPhone, setEditedPhone] = useState<string>("");
  const [phoneUpdating, setPhoneUpdating] = useState<boolean>(false);
  const [isEditingTimeZone, setIsEditingTimeZone] = useState<boolean>(false);
  const [editedTimeZone, setEditedTimeZone] = useState<string>("");

  const OutlineEdit = MdOutlineEdit as any;
  const CloseOutline = IoCloseOutline as any;


  useEffect(() => {
    currentUser?.getIdToken().then((token) => {
      setAuthToken(token);
      GetUserProfileDetails(currentUser.uid, token);
      GetEmployeeFile(token, currentUser.uid, 1, 10);
    });
  }, []);

  const GetUserProfileDetails = async (userId: string, token: string) => {
    setLoading(true);
    try {
      const res = await GetEmployeeProfileDetailsAsync(token, userId);
      if (res.success) {
        setUserDetails(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (err: any) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const [timeOffData, setTimeOffData] = useState<EmployeeTimeOffResponseDto[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [pendingTimeOffCount, setPendingTimeOffCount] = useState<number | 0>(0);

  useEffect(() => {
    const fetchTimeOffs = async () => {
      if (currentUser) {
        try {
          const authToken = await currentUser.getIdToken();
          const userId = currentUser.uid;
          const result = await getUpcomingTimeOffs(userId, authToken);

          if (result.success) {
            setTimeOffData(result.data);
            setPendingTimeOffCount(result.data[0]?.pendingTimeOffCount || 0);
          } else {
            setError(result.message);
          }
        } catch (error: any) {
          setError(error?.message || "Error to fetch the Timeoff Data");
        }
      }
    };

    fetchTimeOffs();
  }, [currentUser]);
  const firstTimeOff = timeOffData?.[0];
  const GetEmployeeFile = async (
    token: string,
    userId: string,
    pageNumber: number,
    pageSize: number
  ) => {
    // setLoading(true);
    const payload: GetEmployeeFilesRequest = {
      userId: userId,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    GetEmployeeFileAsync(token, payload)
      .then((res) => {
        if (res.success) {
          setFilesData(res.data);
        } else {
          toast.error(res.message || "Failed to fetch employee files.");
        }
      })
      .catch((err: any) =>
        toast.error(
          err.message || "An error occurred while fetching employee files."
        )
      );
  };

  const [avatarRefreshKey, setAvatarRefreshKey] = useState<number>(0);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!currentUser?.uid) return;
    const file = event.target.files?.[0];
    if (!file) return;
    setLoading(true);
    uploadAvatar(authToken, currentUser?.uid, file)
      .then((url) => {
        if (url) {
          refreshAvatar(currentUser.uid); // <-- Invalidate cache!
          GetUserProfileDetails(currentUser.uid, authToken);
          setAvatarRefreshKey((prev) => prev + 1); // Refresh AvatarImage
        }
      })
      .catch((err) => {
        console.error("Error uploading avatar:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const InfoRow = ({ label, value, border }: { label: any; value: any; border?: boolean; }) => (
    <div className={`space-y-1 pb-2 ${border ? "border-b border-[#0000000D]" : ""}`}>
      <p className="text-[#6E6E73] m-0 mb-2 text-base">{label}</p>
      <p className="text-base text-[#1D1D1F] m-0">{value}</p>
    </div>
  );


  // const InfoRowaddress = ({ label, value, border }: { label: any; value: any; border?: boolean; }) => (
  //   <div className={`space-y-1 pb-2 ${border ? "border-b border-[#0000000D]" : ""}`}>
  //     <p className="text-[#6E6E73] m-0 mb-2 text-base">{label}</p>
  //     <p className="text-base text-[#1D1D1F] m-0">{value}</p>
  //     <button className="btn"  >Edit</button>
  //   </div>
  // );


  const InfoRowaddress = ({
    label,
    value,
    border,
  }: {
    label: any;
    value: any;
    border?: boolean;
  }) => (
    <div
      className={`pb-2 ${border ? "border-b border-[#0000000D]" : ""
        }`}
    >
      <p className="text-[#6E6E73] m-0 mb-2 text-base">{label}</p>

      <div className="flex items-center justify-between gap-3">
        {isEditingAddress ? (
          <div className="flex items-center gap-2 flex-1">
            <input
              type="text"
              value={editedAddress}
              onChange={(e) => setEditedAddress(e.target.value)}
              className="flex-1 text-base bg-white text-gray-900 caret-black"
              placeholder="Enter address"
              disabled={addressUpdating}
              autoFocus
              style={{
                border: "none",
                background: "transparent",
                outline: "none",
                boxShadow: "none",
                padding: "0px"
              }}
            />
            <button
              onClick={handleSaveAddress}
              disabled={addressUpdating}
              className="text-sm font-medium bg-[#F9F6FF] text-[#333333] hover:bg-transparent disabled:opacity-50 w-fit px-2 rounded-[5px] py-[2px]"
              style={{
                border: "#EFE9FA 1px solid"
              }}
            >
              {addressUpdating ? "Saving..." : "Save"}
            </button>
            <button
              onClick={handleCancelEdit}
              disabled={addressUpdating}
              className="text-xl font-medium text-[#616161] hover:text-red-700"
            >
              <CloseOutline />{""}
            </button>
          </div>
        ) : (
          <>
            <p className="text-base text-[#1D1D1F] m-0">{value}</p>
            <button
              onClick={handleEditAddress}
              className="font-medium text-[#1D1D1F] hover:text-blue-700 
              hover:underline transition-colors"
            >
              <img
                src={EDITICON}
                alt="Edit"
                className="w-5 h-5"
              />
            </button>
          </>
        )}
      </div>
    </div>
  );


  const formatDateProfile = (dateStr?: string) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  useEffect(() => {
    if (currentUser) {
      const storedAvatars = getAvatarsFromStorage();
      if (storedAvatars) {
        const avatar = storedAvatars.find(avatar => avatar.id === currentUser.uid);
        if (avatar) {
          setCurrentAvatar(avatar);
        }
      }
    }
  }, [currentUser]);

  const tabKeyMap: Record<string, string> = {
    "/profile/information": "information",
    "/profile/notifications": "notifications",
    "/profile/reviews": "reviews",
    "/profile/security": "security",
    "/profile/time-off": "time-off",
  };

  const activeTab = tabKeyMap[location.pathname] || "information";

  const handleSelect = (key: string | null) => {
    if (key) {
      navigate(`/profile/${key}`);
    }
  };

  const handleClickUpdateTimeZone = async () => {
    const token = await currentUser?.getIdToken();
    if (!token || !currentUser) return;

    const payload: UpdateContactAndTimezoneRequest = {
      phoneNumber: null,
      preferredTimeZone: userDetails?.timezone ? userDetails.timezone : null
    }

    try {
      setTimezoneUpdating(true);
      const res = await UpdateContactAndTimezoneAsync(token, currentUser?.uid, payload)
      if (res.success) {
        toast.success("Updated Successfully");
      } else {
        toast.error(res.message);
      }
    } catch (error: any) {
      toast.error(error instanceof AxiosError ? error.response?.data.message : error.message || "Error to update");
    } finally { setTimezoneUpdating(false) }

  }

  const handleEditAddress = () => {
    setEditedAddress(userDetails?.address || "");
    setIsEditingAddress(true);
  }

  const handleSaveAddress = async () => {
    const token = await currentUser?.getIdToken();
    if (!token) return;

    if (!editedAddress.trim()) {
      toast.error("Address is required");
      return;
    }

    const payload: UpdateAddressRequest = {
      address: editedAddress.trim()
    };

    try {
      setAddressUpdating(true);
      const res = await UpdateUserAddressAsync(token, payload);
      if (res.success) {
        toast.success("Address updated successfully");
        setUserDetails(prev => prev ? { ...prev, address: editedAddress } : prev);
        setIsEditingAddress(false);
      } else {
        toast.error(res.message || "Failed to update address");
      }
    } catch (error: any) {
      toast.error(error.message || "Error updating address");
    } finally {
      setAddressUpdating(false);
    }
  }

  const handleCancelEdit = () => {
    setIsEditingAddress(false);
    setEditedAddress("");
  }

  const handleEditPhone = () => {
    setEditedPhone(userDetails?.phoneNumber || "");
    setIsEditingPhone(true);
  };

  const handleCancelPhoneEdit = () => {
    setIsEditingPhone(false);
    setEditedPhone("");
  };

  const handleSavePhone = async () => {
    const token = await currentUser?.getIdToken();
    if (!token || !currentUser) return;

    if (editedPhone.length !== 10) {
      toast.error("Enter a valid US phone number");
      return;
    }

    const payload: UpdateContactAndTimezoneRequest = {
      phoneNumber: editedPhone, // ✅ 1231231234 ONLY
      preferredTimeZone: userDetails?.timezone || null,
    };

    try {
      setPhoneUpdating(true);

      const res = await UpdateContactAndTimezoneAsync(
        token,
        currentUser.uid,
        payload
      );

      if (res.success) {
        toast.success("Phone number updated successfully");

        setUserDetails((prev) =>
          prev ? { ...prev, phoneNumber: editedPhone } : prev
        );

        setIsEditingPhone(false);
      } else {
        toast.error(res.message);
      }
    } catch (error: any) {
      toast.error(
        error instanceof AxiosError
          ? error.response?.data?.message
          : error.message || "Error updating phone number"
      );
    } finally {
      setPhoneUpdating(false);
    }
  };

  const timeZones = [
    { label: "Asia/Kolkata (IST)", value: "Asia/Kolkata" },
    { label: "America/Chicago (CST)", value: "America/Chicago" },
    { label: "America/New_York (EST)", value: "America/New_York" },
    { label: "America/Los_Angeles (PST)", value: "America/Los_Angeles" },
    { label: "Europe/London (GMT)", value: "Europe/London" },
    { label: "Asia/Dubai (GST)", value: "Asia/Dubai" },
    { label: "Asia/Singapore (SGT)", value: "Asia/Singapore" },
    { label: "Australia/Sydney (AEST)", value: "Australia/Sydney" },
  ];

  const handleEditTimeZone = () => {
    setEditedTimeZone(userDetails?.timezone || "");
    setIsEditingTimeZone(true);
  };

  const handleCancelTimeZoneEdit = () => {
    setIsEditingTimeZone(false);
    setEditedTimeZone("");
  };

  const handleSaveTimeZone = async () => {
    const token = await currentUser?.getIdToken();
    if (!token || !currentUser) return;

    if (!editedTimeZone.trim()) {
      toast.error("Please select a timezone");
      return;
    }

    const payload: UpdateContactAndTimezoneRequest = {
      phoneNumber: null,
      preferredTimeZone: editedTimeZone.trim(),
    };

    try {
      setTimezoneUpdating(true);
      const res = await UpdateContactAndTimezoneAsync(
        token,
        currentUser.uid,
        payload
      );

      if (res.success) {
        toast.success("Timezone updated successfully");
        // Refresh user profile details to get updated data from server
        // Use a separate call without showing the loader to avoid UI flicker
        try {
          const refreshRes = await GetEmployeeProfileDetailsAsync(token, currentUser.uid);
          if (refreshRes.success && refreshRes.data) {
            setUserDetails(refreshRes.data);
          }
        } catch (refreshError) {
          // If refresh fails, still update locally
          setUserDetails((prev) =>
            prev ? { ...prev, timezone: editedTimeZone.trim() } : prev
          );
        }
        // Close editing mode after state is updated
        setIsEditingTimeZone(false);
        setEditedTimeZone("");
      } else {
        toast.error(res.message);
      }
    } catch (error: any) {
      toast.error(
        error instanceof AxiosError
          ? error.response?.data.message
          : error.message || "Error updating timezone"
      );
    } finally {
      setTimezoneUpdating(false);
    }
  };

  const isValidUSPhone = (phone: string) => {
    const digits = phone.replace(/\D/g, "");
    return (
      digits.length === 10 ||
      (digits.length === 11 && digits.startsWith("1"))
    );
  };

  const formatUSPhoneForUI = (digits: string) => {
    if (!digits || digits.length !== 10) return "-";

    return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const InfoRowPhone = ({
    label,
    value,
    border,
  }: {
    label: any;
    value: any;
    border?: boolean;
  }) => (
    <div className={`pb-2 ${border ? "border-b border-[#0000000D]" : ""}`}>
      <p className="text-[#6E6E73] m-0 mb-2 text-base">{label}</p>

      <div className="flex items-center justify-between gap-3">
        {isEditingPhone ? (
          <div className="flex items-center gap-2 flex-1">
            <input
              type="tel"
              style={{
                border: "none",
                background: "transparent",
                outline: "none",
                boxShadow: "none",
                padding: "0px"
              }}
              value={editedPhone}
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, "");

                // US number = exactly 10 digits
                if (digits.length <= 10) {
                  setEditedPhone(digits);
                }
              }}
              className="flex-1 text-base bg-white text-gray-900 caret-black"
              placeholder="Enter phone number"
              disabled={phoneUpdating}
              autoFocus
            />

            <button
              onClick={handleSavePhone}
              disabled={phoneUpdating}
              className="text-sm font-medium bg-[#F9F6FF] text-[#333333] hover:bg-transparent disabled:opacity-50 w-fit px-2 rounded-[5px] py-[2px]"
              style={{
                border: "#EFE9FA 1px solid"
              }}
            >
              {phoneUpdating ? "Saving..." : "Save"}
            </button>

            <button
              onClick={handleCancelPhoneEdit}
              disabled={phoneUpdating}
              className="text-xl font-medium text-[#616161] hover:text-red-700"
            >
              <CloseOutline />{""}
            </button>
          </div>
        ) : (
          <>
            <p className="text-base text-[#1D1D1F] m-0">
              {formatUSPhoneForUI(value)}
            </p>
            <button
              onClick={handleEditPhone}
              className="font-medium text-[#1D1D1F] hover:text-blue-700 hover:underline"
            >
              <img
                src={EDITICON}
                alt="Edit"
                className="w-5 h-5"
              />
            </button>
          </>
        )}
      </div>
    </div>
  );

  const InfoRowTimeZone = ({
    label,
    value,
    border,
  }: {
    label: any;
    value: any;
    border?: boolean;
  }) => (
    <div className={`pb-3 ${border ? "border-b border-[#0000000D]" : ""}`}>
      <p className="text-[#6E6E73] m-0 mb-2 text-base">{label}</p>

      <div className="flex items-center justify-between gap-3">
        {isEditingTimeZone ? (
          <div className="flex items-center gap-2 flex-1">
            <select
              value={editedTimeZone}
              onChange={(e) => setEditedTimeZone(e.target.value)}
              className="flex-1 px-2 py-1 text-base rounded bg-white text-gray-900"
              disabled={timeZoneUpdating}
              autoFocus
              style={{
                border: "none",
                // background: "transparent",
                outline: "none",
                boxShadow: "none",
                padding: "0px"
              }}
            >
              <option value="">Select Time Zone</option>
              {timeZones.map((tz) => (
                <option key={tz.value} value={tz.value}>
                  {tz.label}
                </option>
              ))}
            </select>

            <button
              onClick={handleSaveTimeZone}
              disabled={timeZoneUpdating}
              className="text-sm font-medium bg-[#F9F6FF] text-[#333333] hover:bg-transparent disabled:opacity-50 w-fit px-2 rounded-[5px] py-[2px]"
              style={{
                border: "#EFE9FA 1px solid"
              }}
            >
              {timeZoneUpdating ? "Saving..." : "Save"}
            </button>

            <button
              onClick={handleCancelTimeZoneEdit}
              disabled={timeZoneUpdating}
              className="text-xl font-medium text-[#616161] hover:text-red-700"
            >
              <CloseOutline />{""}
            </button>
          </div>
        ) : (
          <>
            <p className="text-base text-[#1D1D1F] m-0">
              {value && value !== "-"
                ? timeZones.find((tz) => tz.value === value)?.label || value
                : "-"}
            </p>
            <button
              onClick={handleEditTimeZone}
              className="font-medium text-[#1D1D1F] hover:text-blue-700 hover:underline"
            >
              <img
                src={EDITICON}
                alt="Edit"
                className="w-5 h-5"
              />
            </button>
          </>
        )}
      </div>
    </div>
  );

  return (
    <>
      <div className="bg-white rounded-[10px] p-[20px]">
        <div className="flex flex-col gap-6 w-full lg:flex-row lg:flex-nowrap lg:overflow-x-auto" style={{ alignItems: "start" }}>
          <div className="bg-white border rounded-xl p-6 bg-no-repeat bg-[length:100%_125px] bg-top 
             w-full lg:w-[320px] lg:min-w-[320px] 2xl:w-[394px] 2xl:min-w-[394px] shrink"
            style={{ backgroundImage: `url(${FrameProfile})` }}>
            <div className="flex flex-col items-center ">
              <div className="profile_info_upload">
                <label htmlFor="upload">
                  <div className="user_upload min-w-24 lg:min-w-[120px] min-h-24 lg:min-h-[120px]" style={{ cursor: "pointer" }}>
                    {/* <img
                  src={userDetails?.avatarURL || avtar}
                  alt="profile"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = avtar;
                  }}
                /> */}
                    <AvatarImage size="md" userId={currentUser?.uid || ""} key={avatarRefreshKey} />
                  </div>
                  <div className="edit_img ">
                    <img className="w-9 h-9" src={editicon} alt="edit icon" />
                  </div>
                </label>
                <input
                  type="file"
                  id="upload"
                  className="d-none"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </div>
              <h2 className="text-base font-semibold m-0">{userDetails?.firstName} {userDetails?.lastName}</h2>
              <p className="text-base min-w-[150px] text-center text-[#747474] m-0 mt-1 bg-[#F9F6FF] rounded-full px-4 py-1">{userDetails?.positions?.reduce((prev: string, current: string) =>
                positionRanks[prev] > positionRanks[current]
                  ? prev
                  : current
              )}</p>
            </div>

            <div className="mt-16 space-y-4 text-sm">
              {/* <InfoRow label="Employee ID" border value={userDetails?. || "-"} /> */}
              <InfoRow label="Email" border value={userDetails?.email || "-"} />
              {/* <InfoRow label="Phone" border value={formatPhoneNumber(userDetails?.phoneNumber || "-")} /> */}
              <InfoRowPhone
                label="Phone"
                value={userDetails?.phoneNumber || "-"}
                border
              />
              <InfoRowaddress label="Address" value={userDetails?.address || "-"} border />
              <h3 className="text-xl lg:text-2xl pt-2 text-[#1D1D1F]">Professional Details</h3>
              <InfoRow
                label="Start Date"
                border
                value={formatDateProfile(userDetails?.joinDate)}
              />
              <InfoRow
                label="Position"
                border
                value={userDetails?.positions?.reduce((prev: string, current: string) =>
                  positionRanks[prev] > positionRanks[current]
                    ? prev
                    : current
                )}
              />
              <InfoRow
                label="Office Location"
                border
                value={
                  userDetails?.regions?.length
                    ? userDetails.regions.map(r => r.name).join(", ")
                    : "-"
                }
              />

              <InfoRowTimeZone
                label="Time Zone"
                value={userDetails?.timezone || "-"}
              />
{userDetails?.positions?.includes("SC") &&
 Array.isArray(userDetails?.waiverFamilies) &&
 userDetails.waiverFamilies.length > 0 && (
  <InfoRow
    label="Waiver Family Type"
    value={userDetails.waiverFamilies.join(", ")}
    border
  />
)}

              {/* <div className="stats">
                <h3>Time Zone</h3>
                <div className="timezone-input-group">
                  <select
                    value={userDetails?.timezone || ""}
                    onChange={(e) =>
                      setUserDetails((prev) =>
                        prev ? { ...prev, timezone: e.target.value } : prev
                      )
                    }
                    className="form-select"
                  >
                    <option value="">Select Time Zone</option>
                    {timeZones.map((tz) => (
                      <option key={tz.value} value={tz.value}>
                        {tz.label}
                      </option>
                    ))}
                  </select>
                  <button className="btn btn-primary btn-sm timezone-btn" type="button" onClick={handleClickUpdateTimeZone}>
                    {timeZoneUpdating ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faCheck} />}
                  </button>
                </div>
              </div> */}
            </div>
          </div>
          <div className="w-full">
            <Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={handleSelect}>
              <div className="tab_flx mb-6">
                <Nav variant="pills" className="common_tab">
                  <Nav.Item>
                    <Nav.Link eventKey="information">Profile Information</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="notifications">Notifications</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="reviews">Reviews</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="security">Security</Nav.Link>
                  </Nav.Item>

                </Nav>
              </div>
              <Tab.Content>
                <Routes>
                  <Route path="/" element={<Profileinformationtab />} />
                  <Route path="information" element={<Profileinformationtab />} />
                  <Route path="notifications" element={<Notificationtab />} />
                  <Route path="reviews" element={<Reviewtab />} />
                  <Route path="security" element={<Securitytab />} />
                </Routes>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>

    </>
  );
};

export default Profile;
